export default {
  category: [],
  subCategory: {},
  goodsByCategory: []
}



// WEBPACK FOOTER //
// ./src/logic/category/state.js